export default {"src":"/_next/static/media/dark_icon.e2efa654.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};